import { makeAutoObservable } from 'mobx';

export type ToastType = 'success' | 'error' | 'info';

export interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
}

class ToastStore {
  items: ToastItem[] = [];
  private nextId = 0;

  constructor() {
    makeAutoObservable(this);
  }

  show(message: string, type: ToastType = 'success', duration = 3500) {
    const id = this.nextId++;
    this.items.push({ id, message, type });
    setTimeout(() => this.dismiss(id), duration);
  }

  dismiss(id: number) {
    this.items = this.items.filter((toast) => toast.id !== id);
  }
}

export const toastStore = new ToastStore();
